export default __webpack_public_path__ + "static/media/3-bm.99f63ba1.webp";